<template>
    <InformeCard id="tipos-abono" name="tipos-abono" collapsable="true" title="Desglose por tipo de abono">
        <ContentOrLoading>
            <GChart
                v-if="!loading"
                type="PieChart"
                :data="chartData"
                :options="chartOptions"
            />
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
    data() {
        return {
            loading: false,
            valores: null,
            desglose: null,
            chartOptions: {
                height: 364,
                chartArea:{width:'auto'},
                legend: {
                    textStyle: { fontSize: 8 }
                },
                pieHole: 0.4
            }
        }
    },
    methods: {
        getTiposAbonos() {
            this.loading = true;

            const params = {
                filters : {},
                lista_id: this.lista_id
            };

            if (this.fecha_inicio && this.fecha_fin) {
                params.filters.fecha_inicio = this.fecha_inicio;
                params.filters.fecha_fin = this.fecha_fin;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.desglose-tipos'), params).then(res => {
                this.valores = res.data.data;
                this.setDesglose();
            }).finally(() => this.loading = false);
        },
        setDesglose() {
            var desglose = [
                [], []
            ];

            for (var i = 0; i < this.valores.length; i++) {
                if(desglose[0].indexOf(this.valores[i].name) == -1) {
                    desglose[0].push(this.valores[i].name);

                    desglose[1].push(this.valores[i].total);
                } else {
                    var index = desglose[0].indexOf(this.valores[i].name);

                    desglose[1][index] = desglose[1][index] + this.valores[i].total;
                }
            }

            var array = [
                ['Tipo de abono', 'Vendidos']
            ];

            for (var x = 0; x < desglose[0].length; x++) {
                array.push([
                    desglose[0][x],
                    desglose[1][x]
                ]);
            }

            this.desglose = array;
        },
    },
    computed: {
        chartData() {
            var data = null;
            if(this.desglose) {
                data = this.desglose;
            } else {
                data = null;
            }

            return data;
        }
    },
    created() {
        this.getTiposAbonos();
    },
    components: {
        InformeCard,
    }
}
</script>
